import styled from 'styled-components';
export const ParamDescriptorWrapper = styled.div.withConfig({
  displayName: "Helpers__ParamDescriptorWrapper",
  componentId: "z2yie7-0"
})(["width:136px;"]);